<script lang="ts" setup>
import ShareQuoteDialogV1 from '@/components/ShareQuoteDialogV1.vue'
import ShareQuoteDialogV2 from '@/components/ShareQuoteDialogV2.vue'
import { useSplit } from '@/composables/useSplit'
import { SplitFeatureFlag } from '@/utils/enum'
import { onMounted, ref } from 'vue'
const props = defineProps<{
  quoteId: number
}>()

const { isFeatureEnabled } = useSplit()
const isUserRoleManagementEnabled = ref(false)

onMounted(async () => {
  isUserRoleManagementEnabled.value = await isFeatureEnabled(SplitFeatureFlag.UserRoleManagement)
})
</script>

<template>
  <ShareQuoteDialogV1 v-if="!isUserRoleManagementEnabled" :quote-id="quoteId" />
  <ShareQuoteDialogV2 v-else :quote-id="quoteId" />
</template>
